import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import organizationsReducer from './slices/organizationsSlice';
import statisticsReducer from './slices/statisticsSlice';
import patientsReducer from './slices/patientsSlice';
import programDataReducer from './slices/programDataSlice';

export const store = configureStore({
  reducer: {
    organizations: organizationsReducer,
    statistics: statisticsReducer,
    patients: patientsReducer,
    programData: programDataReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
